module.exports = __webpack_public_path__ + "manageStatic/img/dujia.d26f854a.png";